import tags from './tags';
import toplist from './toplist';
import quiz from './quiz';
import info from './info';
import activities from './activities';

export default {
  tags,
  toplist,
  quiz,
  info,
  meta: {
    title: 'Ducky | Klimautfordring',
    short_name: 'Klimautfordring',
    description:
      'Konkurrer i utslippskutt på skolen eller jobben, og endre vaner med enkle aktiviteter i hverdagen.',
  },
  AddToHomeScreen: {
    title: 'Legg til på hjem-skjerm',
    text: 'MARKDOWN:Vil du ha rask tilgang til utfordringen? Trykk på **"del"-knappen** i midten av nettleser-menyen nedenfor, og velg **Legg til Hjem**.',
  },
  activities,
  kgCO2e: 'kgCO\u2082e',
  points: 'Poeng',
  log_all: 'Logg alle',
  pageTitles: {
    overview: 'Utfordringsoversikt',
    leaderboard: 'Topplister',
    log: 'Logg klimaaktiviteter',
    feed: 'Siste hendelser',
    info: 'Om utfordringen',
  },
  GMod08: {
    co2: {
      heading: 'Innsparing kgCO\u2082e',
      content1:
        'Fotavtrykket ditt er det samlede utslippet av alle handlinger du gjør i din hverdag, ofte uttrykt i antall kilo CO\u2082-ekvivalenter (kgCO\u2082e).',
      content2:
        'Her på Ducky representerer blad-ikonet mengden kgCO\u2082e du sparer ved å gjennomføre bærekraftige tiltak sammenliknet med vanene til en gjennomsnittlig norsk person.',
    },
    points: {
      heading: 'Poeng opptjent',
      content1:
        'I Ducky representerer stjerneikonet antall poeng du får for å utføre bærekraftige aktiviteter.',
      content2: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    },
    close: 'LUKK',
  },
  GMod09: {
    heading_atWork: 'Hei %{userName}, du er en helt!',
    heading_co2: 'Hei %{userName}, du er en klimahelt!',
    heading_plastic: 'Hei %{userName}, du er en plasthelt!',
    heading_workTransport: 'Hei %{userName}, du er en arbeidstransporthelt!',
    heading_foodWaste: 'Hei %{userName}, du er en matsvinnhelt!',
    heading_mindfulCitizen: 'Hei %{userName}, din omsorgsfulle helt!',
    heading_general: 'Hei %{userName}, du er en helt!',
    intro_atWork: 'Du er nå en del av en utfordring som varer i %{duration}.',
    intro_co2: 'Du er nå en del av en klimautfordring som varer i %{duration}.',
    intro_plastic:
      'Du er nå en del av en plastutfordring som varer i %{duration}.',
    intro_workTransport:
      'Du er nå en del av en arbeidstransportutfordring som varer i %{duration}.',
    intro_foodWaste:
      'Du er nå en del av en matsvinnufordring som varer i %{duration}.',
    intro_mindfulCitizen:
      'Du er nå en del av den %{duration} omsorgsfull innbygger utfordringen.',
    intro_general: 'Du er nå en del av en utfordring som varer i %{duration}.',
    tagline_atWork_co2:
      'Prøv ut så mange på jobb aktiviteter du kan og spar CO₂ for ditt lag.',
    tagline_co2_co2:
      'Prøv ut så mange klimaaktiviteter du kan og spar CO₂ for ditt lag.',
    tagline_plastic_co2:
      'Prøv ut så mange plastaktiviteter du kan og spar CO₂ for ditt lag.',
    tagline_workTransport_co2:
      'Prøv ut så mange arbeidstransportaktiviteter du kan og spar CO₂ for ditt lag.',
    tagline_foodWaste_co2:
      'Prøv ut så mange matsvinnaktiviteter du kan og spar CO₂ for ditt lag.',
    tagline_mindfulCitizen_co2:
      'Prøv ut så mange omsorgsfulle aktiviteter du kan og spar CO₂ for laget ditt.',
    tagline_general_co2:
      'Prøv ut så mange aktiviteter du kan og spar CO₂ for ditt lag.',
    tagline_atWork_points:
      'Prøv ut så mange på jobb aktiviteter du kan og opptjen poeng for ditt lag.',
    tagline_co2_points:
      'Prøv ut så mange klimaaktiviteter du kan og opptjen poeng for ditt lag.',
    tagline_plastic_points:
      'Prøv ut så mange plastaktiviteter du kan og opptjen poeng for ditt lag.',
    tagline_workTransport_points:
      'Prøv ut så mange arbeidstransportaktiviteter du kan og opptjen poeng for ditt lag.',
    tagline_foodWaste_points:
      'Prøv ut så mange matsvinnaktiviteter du kan og opptjen poeng for ditt lag.',
    tagline_mindfulCitizen_points:
      'Prøv ut så mange omsorgsfulle aktiviteter du kan og tjen opp poeng for laget ditt.',
    tagline_general_points:
      'Prøv ut så mange aktiviteter du kan og opptjen poeng for ditt lag.',
    start_button: 'KOM I GANG!',
    more_button: 'JEG VIL VITE MER',
    details_title1: 'Enkle hverdagsaktiviteter',
    details_text1: 'Enkle og effektive aktiviteter alle kan gjøre hver dag!',
    details_title2: 'Innsikt for hver aktivitet',
    details_text2:
      'Lær hvorfor aktivitetene er viktige og hvordan de påvirker miljøet vårt.',
    details_title3: 'Konkurrer på lag',
    details_text3:
      'Jobb sammen mot andre lag og se hvem som har størst påvirkning.',
    details_title4: 'Enkle visualiseringer',
    details_text4:
      'Forstå med enkle visualiseringer alle kan kjenne seg igjen i.',
    details_title5: 'Forstå helheten',
    details_text5:
      'Få innsikt i hvordan mange små handlinger skaper store, positive miljøpåvirkninger.',
    details_title6: 'Få umiddelbar feedback',
    details_text6:
      'Følg fremgangen i konkurransen LIVE med visualiseringer i sanntid.',
    footer: 'JEG FORSTÅR',
  },
  GMod10: {
    heading: 'Dette kan du %{userName}!',
    content: 'Kom i gang og inspirer andre til å bli med!',
    start_button: 'GÅ TIL UTFORDRINGEN',
    revisit_button: 'TA GJENNOMGANGEN PÅ NYTT',
  },
  GMod16: {
    leaderboard_info: 'Info om topplisten',
    co2_per_team: 'CO\u2082 per lag',
    shows_average_co2:
      'Viser gjennomsnittlig kg CO\u2082e spart per deltaker på hvert lag.',
    points_per_team: 'Poeng per lag',
    shows_average_points:
      'Viser gjennomsnittlig poeng per deltaker på hvert lag.',
    participation_per_team: 'Deltagelse per lag',
    shows_percentage_participating:
      'Viser hvor mange prosent som deltar av de som har blitt invitert på hvert lag',
    close: 'Lukk',
  },
  StreakModal: {
    day_streaks: 'Din streak',
    log_activities: 'Logg aktiviteter hver dag for å opprettholde den!',
    days_logged: 'Dager du logget',
    days_missed: 'Dager du ikke logget',
  },
  GoalModal: {
    set_goal: 'Sett et personlig mål',
    1: {
      title: 'Øko-kriger',
      text: 'Du står for det du tror på og er villig til å lære. Målet ditt er å spare som gjennomsnittet: %{goal} %{unit} i løpet av %{length} dager',
    },
    2: {
      title: 'Planetforkjemper',
      text: 'Du gjør allerede en forskjell. Ditt mål er å være bedre enn gjennomsnittet; %{goal} %{unit} i løpet av %{length} dager',
    },
    3: {
      title: 'Klimamester',
      text: 'En erfaren planetforkjemper som også inspirerer andre. Prøv å spare %{goal} %{unit} i løpet av %{length} dager',
    },
    amend_this: 'Du kan endre dette når som helst',
    cancel: 'AVBRYT',
    save_goal: 'LAGRE MÅL',
  },
  NpsModal: {
    feedback_matters: 'Din tilbakemelding er viktig for oss! 😇',
    likely_to_recommend:
      'Hvor sannsynlig er det at du vil anbefale Ducky til andre?',
    not_likely: 'ikke sannsynlig',
    very_likely: 'svært sannsynlig',
    important_reason: 'Hva er den viktigste grunnen til poengsummen din?',
    share_thoughts: 'Del tankene dine her',
    cancel: 'AVBRYT',
    back: 'TILBAKE',
    send_feedback: 'SEND TILBAKEMELDING',
    thanks: 'Takk for at du deler tilbakemelding',
    party: '🎉',
    close: 'LUKK',
  },
  goal_achieved: {
    1: {
      title: 'Bra jobbet Øko-kriger!',
      text: 'Du har nådd ditt personlige mål på %{goal} %{unit}',
    },
    2: {
      title: 'Bra jobbet Planetforkjemper!',
      text: 'Du har nådd ditt personlige mål på %{goal} %{unit}',
    },
    3: {
      title: 'Wow. Du klarte det!',
      text: 'Men laget ditt trenger deg fremdeles! Fortsett å logge',
    },
  },
  participant_goal_achieved: 'nådde et personlig mål på %{goal} %{unit}!',
  participant_goal_set: 'har satt et personlig mål på %{goal} %{unit}!',
  user_quiz_completed: {
    consumption: 'Du scoret %{score}/3 i varer & tjenester-quizen',
    energy: 'Du scoret %{score}/3 i energi-quizen',
    food: 'Du scoret %{score}/3 i mat-quizen',
    transport: 'Du scoret %{score}/3 i transport-quizen',
    microplastics: 'Du scoret %{score}/3 i mikroplastikk-quizen',
  },
  participant_quiz_completed: {
    consumption: 'fullførte en varer & tjenester-quiz',
    energy: 'fullførte en energi-quiz',
    food: 'fullførte en mat-quiz',
    transport: 'fullførte en transport-quiz',
    microplastics: 'fullførte en mikroplastikk-quiz',
  },
  participant_quiz_completed_prompt: {
    consumption: 'Ta quizen om varer og tjenester',
    energy: 'Ta energiquizen',
    food: 'Ta matquizen',
    transport: 'Ta transportquizen',
    microplastics: 'Ta plastquizen',
  },
  user_quiz_completed_nice_work: 'Bra jobba!',
  TabMen03: {
    log: 'Klimaaktiviteter',
    topList: 'Toppliste',
    insights: 'Innsikt',
    latestEvents: 'Hendelser',
  },
  ActMod02: {
    documented_benefits: 'Fordeler:',
    topic_tags: 'Tema:',
    co2_text: 'kgCO\u2082e',
    health_text: 'Helseeffekt',
    points_text: 'Poeng',
    money_text: 'Penger spart',
    time_text: 'Tid spart',
    landuse_text: 'Landbruk',
    social_text: 'Sosial',
    handprint_text: 'Håndavtrykk',
    biodiversity_text: 'Biomangfold',
  },
  COLab01: {
    your_status: 'Din status',
    points: 'Poeng',
    activities: 'Aktiviteter',
    participation: 'deltagelse',
  },
  SeH002: {
    add_favorite: 'Legg til favoritt',
    remove_favorite: 'Fjern favoritt',
    add_habit: 'Legg til vane',
    remove_habit: 'Fjern vane',
  },
  ChaDSc1: {
    day: 'dag %{day}',
    your_co2_savings: 'Din innsparing',
    your_points_savings: 'Dine poeng ',
    your_co2_savings_today: 'Din innsparing - I dag',
    your_points_savings_today: 'Dine poeng - I dag',
    your_co2_savings_today_tooltip: 'Din innsparing (kgCO\u2082e) i dag',
    your_points_savings_today_tooltip: 'Dine poeng - I dag',
    your_co2_savings_tooltip: 'Din innsparing (kgCO\u2082e)',
    your_points_savings_tooltip: 'Dine poeng',
  },
  ChaMeta01: {
    time_til_end: 'til slutt',
    time_til_start: 'til start',
    days_til_end: 'Dager igjen',
    participants: 'Deltagere',
    total_co2: 'Total innsparing',
    ended: 'Sluttet',
    total_co2_tooltip: 'Totalt innspart kgCO\u2082e\r\ni denne utfordringen',
    total_points: 'Opptjente poeng',
    total_points_tooltip: 'Totalt antall opptjente poeng i utfordringen',
    total_activities: 'Aktiviteter loggført',
    total_activities_tooltip:
      'Totalt antall aktiviteter loggført gjennom utfordringen',
    total_default: '-',
    total_default_tooltip: '-',
  },
  ChaMeta09: {
    participation: '% Deltar',
    actions: 'Aktiviteter',
    co2: 'kgCO\u2082e',
    points: 'Poeng',
  },
  ChStPrt1: {
    total_co2_saved: 'Totalt har dere spart over %{co2} kgCO\u2082e',
    main_text:
      'Din besparelse tilsvarer å reise %{convertedDistance}km med %{vehicle}. Dette er omtrent det samme som å %{transportMethod} fra %{from} til %{to}.',
    sub_text: 'Faktisk distanse mellom %{from} og %{to} er %{actualDistance}km',
  },
  ChStPrt3: {
    average_co2_saved:
      'I gjennomsnitt har hver deltager spart %{co2} kgCO\u2082e',
    main_text:
      'Din besparelse tilsvarer å reise %{convertedDistance}km med %{vehicle}. Dette er omtrent det samme som å %{transportMethod} fra %{from} til %{to}.',
    sub_text: 'Faktisk distanse mellom %{from} og %{to} er %{actualDistance}km',
  },
  ChStPrt4: {
    you: 'Deg',
    average_in_team: 'Gjennomsnitt - Ditt lag',
    average_in_section_term: {
      building: 'Gjennomsnitt - Din bygning',
      department: 'Gjennomsnitt - Din avdeling',
      discipline: 'Gjennomsnitt - Ditt fagfelt',
      faculty: 'Gjennomsnitt - Ditt fakultet',
      school: 'Gjennomsnitt - Din skole',
      area: 'Gjennomsnitt - Ditt område',
      city: 'Gjennomsnitt - Din by',
      municipality: 'Gjennomsnitt - Din kommune',
      county_municipality: 'Gjennomsnitt - Ditt fylke',
      country: 'Gjennomsnitt - Ditt land',
      section: 'Gjennomsnitt - Din seksjon',
    },
  },
  ChStPrt7: {
    most_popular_activity: 'Mest populære aktiviteter:',
    activities: 'aktiviteter',
  },
  ChStPrt9: {
    challenge_participation_amount:
      '%{participantCounts} av totalt %{expectedParticipantCounts} inviterte deltagere er med i denne utfordringen.',
  },
  ChaPaM25B: {
    ChaStat1M: {
      loading_translation: 'laster inn oversettelse',
      saving_total: 'Innsparing totalt hos %{organisationName}',
    },
    ChaStat5M: {
      number_of_participants: 'Antall deltagere hos %{organisationName}',
      participants: 'deltagere',
    },
    personal_insights: 'Personlig innsikt',
    challenge_insights: 'Innsikt fra utfordringen',
    no_one_logged: 'Vennligst logg en aktivitet for å se statistikk og innsikt',
    statistics_and_insights: 'Statistikk og innsikt',
    for_this_challenge: 'for denne utfordringen',
  },
  ChaPaD10A: {
    ChaSec02: {
      details_co2: 'Informasjon om Klimautfordringen',
      details_plastic: 'Informasjon om Plastutfordringen',
      details_foodWaste: 'Informasjon om Matsvinnutfordringen',
      details_atWork: 'Informasjon om på jobb-utfordringen',
      prize: 'Premie',
      revisit_tutorial: 'Ta gjennomgangen på nytt',
      challenge_faq: 'FAQ om utfordringen',
      share_feedback: 'Fortell oss hva du synes',
      presented_by: 'Presentert av',
      presents: 'presenterer',
    },
  },
  ChaPaM24A: {
    details_co2: 'Informasjon om Klimautfordringen',
    details_plastic: 'Informasjon om Plastutfordringen',
    details_foodWaste: 'Informasjon om Matsvinnutfordringen',
    details_atWork: 'Informasjon om på jobb-utfordringen',
    prize: 'Premie',
    revisit_tutorial: 'Ta gjennomgangen på nytt',
    challenge_faq: 'Utfordringen FAQ',
  },
  ChaPaD21A: {
    ActItem2: {
      Btn33: 'Logg alle',
    },
    ActItem7: {
      back: 'TILBAKE TIL ALLE',
    },
    Fil01: {
      close_filter: 'LUKK FILTER',
    },
    your_habits: 'Dine vaner',
    press_to_add_habit_activity:
      'Trykk på “LEGG TIL VANE” når du “lærer mer” om hver aktivitet. På denne måten kan du logge alle vanene dine med ett tastetrykk.',
    available_activities: 'Tilgjengelige aktiviteter',
    other_activities: 'Andre aktiviteter',
    placeholderText:
      'Sorter aktiviteter du gjør ofte, eller ønsker å fokusere på, ved å merke dem som vaner.',
    all_activities: 'Alle aktiviteter',
    filter: 'FILTER',
  },
  ChaPaM21A: {
    ActItem2: {
      Btn33: 'Logg alle',
    },
    your_habits: 'Dine vaner',
    press_to_add_habit_activity:
      'Trykk på “LEGG TIL VANE” når du “lærer mer” om hver aktivitet. På denne måten kan du logge alle vanene dine med ett tastetrykk.',
    popular: 'Mest populær hos %{organisationName}',
    energy: 'Energi',
    food: 'Mat',
    consumption: 'Varer & Tjenester',
    tutorial: 'Eksempel',
    transport: 'Transport',
    available_activities: 'Tilgjengelige aktiviteter',
    other_activities: 'Andre aktiviteter',
  },
  ChaPaD22B: {
    LB01: {
      average: 'Gjennomsnitt',
      name: 'Navn',
      activities: 'Aktiviteter',
      deleted_user: 'Slettet bruker',
      toplist_your_team: 'Toppliste - Ditt lag',
    },
  },
  ChaPaM22B: {
    toplist_your_team: 'Ditt lag',
    toplist_view_more: 'Se Alle',
    toplist_view_less: 'Se Mindre',
  },
  latest_events: {
    new: 'Nye',
    earlier: 'Tidligere',
    FeC002: {
      deleted_user: 'Slettet bruker',
    },
    FeC003: {
      deleted_user: 'Slettet bruker',
      participating_in_your_team: 'deltar nå på ditt lag.',
    },
    FeC004: {
      your_team: 'Ditt lag',
      deleted_user: 'Slettet bruker',
      you_are_participating: 'Du deltar nå i denne utfordringen',
      challenge_participation_subtext:
        'sammen med %{smart_count} annen person! |||| sammen med %{smart_count} andre personer!',
    },
    FeC005A: {
      now_started: 'Utfordringen er nå i gang!',
    },
    FeC005B: {
      now_complete: 'Utfordringen er nå ferdig',
    },
    FeC006: {
      new_position_on_toplist: {
        co2: 'Ny plassering på CO\u2082-topplisten',
        points: 'Ny plassering på poenglisten',
      },
      new_team_rank: 'Ditt lag er nå nummer %{position}',
      position_decreased_from_yesterday:
        'Ned %{smart_count} plassering fra i går |||| Ned %{smart_count} plasseringer fra i går',
      position_increased_from_yesterday:
        'Opp %{smart_count} plassering fra i går |||| Opp %{smart_count} plasseringer fra i går',
      position_similar_to_yesterday: 'Samme plassering som i går',
    },
    FeC007: {
      new_level_for_your_team: 'Nytt nivå for ditt lag',
      loading_translation: 'laster oversettelse',
      your_team_milestone_saving:
        'Ditt lag har i snitt spart mer enn %{co2} kgCO\u2082 per deltager',
    },
    FeC008: {
      notification: 'Melding',
    },
    UserGoalCompleted: {
      reached_your_goal: 'Du har nådd ditt personlig mål på %{goal} %{unit}!',
    },
  },
  ChaPaM23B: {
    recent_activity: 'Nylig aktivitet',
    FeC002: {
      deleted_user: 'Slettet bruker',
    },
    FeC003: {
      deleted_user: 'Slettet bruker',
      participating_in_your_team: 'deltar nå på ditt lag.',
    },
    FeC004: {
      your_team: 'Ditt lag',
      deleted_user: 'Slettet bruker',
      you_are_participating: 'Du deltar nå i denne utfordringen',
      challenge_participation_subtext:
        'sammen med %{smart_count} annen person! |||| sammen med %{smart_count} andre personer!',
    },
    FeC005A: {
      now_started: 'Utfordringen er nå i gang!',
    },
    FeC005B: {
      now_complete: 'Utfordringen er nå ferdig',
    },
    FeC007: {
      new_level_for_your_team: 'Nytt nivå for ditt lag',
      loading_translation: 'laster oversettelse',
      your_team_milestone_saving:
        'Ditt lag har i snitt spart mer enn %{co2} kgCO\u2082 per deltager',
    },
  },
  ChaPaD24B: {
    PlaHo01: {
      no_one_logged:
        'Vennligst logg en aktivitet for å få innsikt i utfordringen.',
    },
    ChaStat1D: {
      saving_total: 'Innsparing totalt hos %{organisationName}',
      loading_translation: 'laster oversettelse',
      participant_savings_in_section: 'Innsparing per deltager på din enhet',
    },
    ChaStat2BD: {
      loading_translation: 'laster oversettelse',
      PlaHo01: 'Klarer dere å nå gjennomsnittlig innsparing på 10 kgCO\u2082e?',
      participant_savings:
        'Gjennomsnittlig besparelse per deltaker hos %{organisationName}',
    },
    ChaStat4D: {
      registered_activities: 'Registrerte aktiviteter hos %{organisationName}',
      activities: 'Aktiviteter',
    },
    ChaStat5D: {
      number_of_participants: 'Antall deltagere hos %{organisationName}',
      participants: 'deltagere',
    },
    PersonalInsights: {
      your_daily_savings: {
        co2: 'Din daglige innsparing',
        points: 'Dine daglige poeng',
        default: '-',
      },
      your_total_savings: {
        co2: 'Din totale innsparing',
        points: 'Dine totale poeng',
        default: '-',
      },
      translate: {
        are_you_able: 'Klarer du å spare 10kg kgCO\u2082e eller mer?',
      },
      day: 'Dag %{day}',
      tooltip: {
        co2: 'Din totale innsparing (kgCO\u2082e)',
        points: 'Dine totale poeng',
        default: '-',
      },
      streaks: {
        title: {
          track_days: 'Se dine aktive dager',
          x_day_streak: 'Du har for tiden en %{streak}-dagers streak!',
          missed_a_day: 'Det ser ut som du glemte å logge en dag',
          logged_x: 'Du logget %{totalLogged} av %{totalDays} dager',
          logged_every: 'Du logget aktiviteter hver dag!',
        },
        text: {
          get_a_streak: 'Klarer du en %{totalDays}-dagers streak?',
          keep_it_going: 'Logg aktiviteter hver dag for å holde den gående!',
          lost_streak: 'Du har mistet streaken din',
          blank: '',
          nice_work: 'Bra jobba',
        },
      },
      goals: {
        goal: 'Ditt mål',
        set_goal: 'SETT ET PERSONLIG MÅL',
        edit_goal: 'Rediger mål',
        view_impact: 'SE DIN PÅVIRKNING',
        set_a_new_goal: 'Sett et nytt mål',
      },
    },
  },
  ChaPaD24M: {
    ChaStat2BM: {
      PlaHo01: 'Klarer dere å nå gjennomsnittlig innsparing på 10 kgCO\u2082e?',
      participant_savings:
        'Gjennomsnittlig besparelse per deltaker hos %{organisationName}',
    },
    ChaStat4M: {
      registered_activities: 'Registrerte aktiviteter hos %{organisationName}',
      activities: 'Aktiviteter',
    },
    loading_translation: 'laster oversettelse',
    participant_savings_in_section: 'Innsparing per deltager på din enhet',
  },
  ChaPaDCB: {
    ChaCo03: {
      your_team: 'Ditt lag',
      saving_kgCO2e:
        'Gjennomsnittlig kg CO\u2082e spart per deltaker på dette laget',
      points_earned:
        'Gjennomsnittlig opptjente poeng per deltaker på dette laget',
      percentage_participating: 'Prosentandel av de som deltar på dette laget',
      logged_actions: 'Antall loggede aktiviteter',
    },
    ChaCo05: {
      saving_per_team: 'Innsparing per lag',
    },
  },
  ChaPaMCB: {
    ChaMeta10: {
      your_team: 'Ditt lag',
    },
    title: {
      points: 'Poeng per lag',
      co2: 'CO\u2082 per lag',
      participation: 'Deltagelse per lag',
      actions: 'Aktiviteter',
    },
    buttons: {
      points: 'Poeng per lag',
      co2: 'CO\u2082 per lag',
      participation: 'Deltagelse per lag',
      learn_more: 'Lær mer',
      see_section_teams: 'Se lag i min seksjon',
      see_challenge_teams: 'Nærmeste lag i utfordringen',
      actions: 'Aktiviteter',
    },
  },
  FeC1: {
    attending: 'Ble med',
    deleted_user: 'Slettet bruker',
    members_in_your_team:
      '%{smart_count} medlem (ditt lag) |||| %{smart_count} medlemmer (ditt lag)',
  },
  LBHead8: {
    saving_co2: 'Innspart kgCO\u2082e',
    saving_points: 'Opptjente poeng',
  },
  tutorial: {
    continue: 'FORTSETT GJENNOMGANGEN',
    back: 'Tilbake',
    next: 'Neste',
    finish: 'FERDIG',
    PopUp00: {
      title: 'Få tilgang til alle aktivitetene',
      text: 'MARKDOWN:ved å trykke på **+** knappen',
    },
    PopUp01: {
      title: 'Logg en aktivitet du prøvde',
      text: 'i dag ved å trykke på haka',
    },
    PopUp02: {
      title: 'Wow! Så enkelt er',
      text_co2: 'det å spare CO\u2082!',
      text_points: 'det å opptjene poeng!',
    },
  },
  tips: {
    find_activities_easier: 'Gjør det lettere å søke etter aktiviteter',
    log_missed_activities: 'Logg aktiviteter for dager du glemte',
  },
  status_bar: {
    reminders: 'Aktivere påminnelser?',
    read_more: 'LES MER',
  },
};
